<template>
    <div id="processforms">
        <div class="container">
            <div class="row-fluid clearfix">
                <div class="w-100">
                    <h4>Standards and Processes</h4>
                    <v-btn 
                        rounded
                        class="add-button"
                        v-on:click="addStandardForm()"
                    >
                        Add Standard
                    </v-btn>
                </div>
            </div>
            <div class="chart" v-for="qstandard in standards" :key="qstandard.id">
                <ProcessChart :standard="qstandard" />
            </div>
        </div>   
        
        <!-- Modal dialog -->
        <modal-dialog-form
        :title="modal_title"
        :showModalDialog="showModalDialog"
        :fields_to_collect="fields_to_collect"
        :submit_button_text="submit_button_caption"
        @close-dialog="toggle_dialog"
        @submit="addStandard"
        >
        </modal-dialog-form>
        <!--  /Modal dialog -->  
    </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import Roles from '@/api/Roles'
import ProcessChart from './../components/process/ProcessChart'
import ModalDialogForm from '@/components/explorer/ModalDialog'
import QStandard from '@/api/Standard'



export default {
    name: 'qprocess_map',
    cache: false,
    
    data: function() {
        return {
            loading: false,
            message: null,
            current_standard_id: null,
            standards: [],
            currentStandard: {},
            newStandard: {},
            processes: [],
            currentProcess: {},
            newProcess: {},
            newPermission: {},
            aspects: [],
            newAspect: {},
            current_standard_aspects: [],
            allRoles: [],
            allDepartments: [],
            mapstandard: {},
            showModalDialog: false,
            modal_title:"ADD STANDARD",
            fields_to_collect:[
              [{
                id:	"name",
                label:	"Nombre",
                required:	false,
                value:	null,
                readonly:	false,
                hidden:	null,
                cols:	8,
                class:	null,
                component:	"TextInput",
                placeholder:"Enter Name"
              }]
            ],
            submit_button_caption:"GUARDAR" // Harcoded text
        }
    },    
    components: { ProcessChart, ModalDialogForm  },
    computed: mapState(['sitePath']),
    mounted: function() {
        this.getStandards()
    },
    methods: {

        addStandardForm: function() {
            this.message = ''
            this.newStandard = {}
            // this.$refs.addmodalstandard.show()
            this.showModalDialog = true
        },

        addStandard: function(formdata) {
            // if (evt) evt.preventDefault()

            this.loading = true
            this.message = ''
            QStandard.createQStandard(this.sitePath, formdata)
            .then(() => {
                // this.loading = false
                this.getStandards(this.sitePath)
                // this.$refs.addmodalstandard.hide()
                this.toggle_dialog()
                this.$root.$loader.hide()
                })
                .catch(err => {
                    //TODO:
                    this.render_form_errors(err)
                })

            // this.$http
            //     .post(
            //     this.$base + '/api/v1' + this.$session.get('site') + '/standard/',
            //     this.newStandard,
            //     )
            //     .then(() => {
            //     this.loading = false
            //     this.getStandards()
            //     this.$refs.addmodalstandard.hide()
            //     })
            //     .catch(err => {
            //     this.render_form_errors(err)
            //     })
        },
        getStandards: function() {
            // this.loading = true
            // this.$http
            //     .get(this.$base + '/api/v1' + this.$session.get('site') + '/standard/')
            //     .then(response => {
            //     this.standards = response.data['results']
            //     this.loading = false
            //     })
            //     .catch(err => {
            //     this.loading = false
            //     alert(err)
            //     })
            QStandard.getQStandardItems(this.$session.get('site'))
            .then(data => {
                this.standards = data['results']
                this.loading = false
                })
                .catch(err => {
                this.loading = false
                alert(err)
                })
        },
        toggle_dialog() {
            this.showModalDialog = false            
            // this.$root.$loader.hide('I completed some action! Yay!', { timeout: 5000, location: 'top' }, () => { console.log( 'Callback after snackbar hidden' ) })
        },
    }
}
</script>


<style lang="scss">
  @import "@/sass/processmap.scss";
</style>
